import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    supportvideoList: [],
    supportvideo: null,
    links: null,
    meta: null,
    filter: {
      tab: null,
      keyword: '',
      status: '',
    },
  },
  mutations: {
    CLEAR_ALL(state) {
      state.supportvideoList = [];
      state.supportvideo = null;
      state.filter = {
        keyword: null,
        status: null,
        tab: null,
      };
    },
    SET_SUPPORTVIDEOLIST(state, data) {
      state.supportvideoList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_SUPPORTVIDEO(state, data) {
      state.supportvideo = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setSupportVideo({ commit }, data) {
      commit('SET_SUPPORTVIDEO', data);
    },

    find({ commit, state }) {
      let url = `/supportvideo?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('SupportVideo'));
          return response.body;
        })
        .then((response) => {
          commit('SET_SUPPORTVIDEOLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/supportvideo/${id}`)
        .then((response) => response.body)
        .then(typeAs('SupportVideo'))
        .then((item) => {
          commit('SET_SUPPORTVIDEO', item);
        });
    },

    destroy(_, id) {
      return http(`/supportvideo/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/supportvideo/${id}`, { method: 'PUT', data })
        : http('/supportvideo', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/supportvideo/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },
    // 取得所屬類別
    getVideoCates(_, id) {
      const request = id
        ? http(`/videocatebyID/${id}`)
        : http('/videocate/all');
      return request.then((response) => response.body);
    },
  },
};
